// Below-the-fold code on a pre-rendered (hydrated) page waits for the first
// user interaction. Until then React keeps the server HTML of those Suspense
// boundaries as-is (content, links and text stay visible and crawlable), so
// the main thread is free during load — mobile TBT was ~1.1s from hydrating
// ~30 below-fold sections at once. Client-rendered pages and SSR are unchanged.
let pending = null;

export default function afterFirstInteraction() {
    if (typeof window === "undefined" || !window.__WZ_PRERENDERED) return Promise.resolve();
    if (!pending) {
        pending = new Promise((resolve) => {
            const events = ["scroll", "wheel", "touchstart", "pointerdown", "keydown", "mousemove"];
            const go = () => {
                events.forEach((e) => window.removeEventListener(e, go, true));
                resolve();
            };
            events.forEach((e) => window.addEventListener(e, go, { capture: true, passive: true }));
        });
    }
    return pending;
}
